<script lang="ts">
  import { InboxWorkflowPreconfigurationBox } from "@kontextwerk/control-web-frame"
  import { type InboxWorkflowPreconfigurationProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import {
    notifyInboxWorkflowPreconfigurationApplyResult,
    resolveInboxWorkflowPreconfigurationTargets,
  } from "@kontextwerk/control-web-frame"
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import { propertyCustomerRoleOptions } from "../../../../../../../../../../../../_shared/_logic/customer-roles"
  import type { WrongRecipientReplacementDraft, WrongRecipientReplacementRow } from "../../contract"
  import { updateWrongRecipientDraftField } from "../../_shared/_logic/table-rows"
  import {
    KEEP_PRECONFIGURATION_VALUE,
    isKeepPreconfigurationChoice,
    withKeepPreconfigurationOption,
    type PreconfigurationChoice,
  } from "../../../../../../../../../../../../_shared/_logic/preconfiguration-keep"

  type ReplaceAction = WrongRecipientReplacementDraft["action"]
  let {
    rows,
    selectedIds,
    draftFor,
    patchDraft,
    disabled = false,
  }: InboxWorkflowPreconfigurationProps<
    WrongRecipientReplacementRow,
    WrongRecipientReplacementDraft
  > = $props()

  // Correction and role start per row from the reported replacement, so both keep by default.
  let action = $state<PreconfigurationChoice<ReplaceAction>>(KEEP_PRECONFIGURATION_VALUE)
  let role = $state<PreconfigurationChoice<string>>(KEEP_PRECONFIGURATION_VALUE)

  const targetResolution = $derived(
    resolveInboxWorkflowPreconfigurationTargets({
      rows,
      selectedIds,
      getId: (row) => row.actionCaseId,
      isEligible: (row) => !row.disabled,
    }),
  )

  const apply = () => {
    for (const row of targetResolution.targetRows) {
      const draft = draftFor(row)
      let next: WrongRecipientReplacementDraft = isKeepPreconfigurationChoice(action)
        ? draft
        : { ...draft, action }

      if (next.action === "replace" && !isKeepPreconfigurationChoice(role)) {
        next = updateWrongRecipientDraftField(next, "role", role, "preconfiguration")
      }

      if (next !== draft) patchDraft(row, next)
    }
    notifyInboxWorkflowPreconfigurationApplyResult({
      total: targetResolution.targetRows.length + targetResolution.skippedRows.length,
      applied: targetResolution.targetRows.length,
      skipped: targetResolution.skippedRows.length,
    })
  }
</script>

<InboxWorkflowPreconfigurationBox
  selectedCount={selectedIds.length}
  targetCount={targetResolution.targetRows.length}
  {disabled}
  onApply={apply}
>
  <div class="preconfiguration-grid">
    <Input
      type="select"
      label="Korrektur"
      bind:value={action}
      brightBackground={false}
      surfaceTone="dark"
      options={withKeepPreconfigurationOption([
        { value: "replace", name: "Ersetzen" },
        { value: "remove", name: "Entfernen" },
      ])}
    />
    <Input
      type="select"
      label="Welche Rolle hat der neue Ansprechpartner?"
      bind:value={role}
      brightBackground={false}
      surfaceTone="dark"
      options={withKeepPreconfigurationOption(
        propertyCustomerRoleOptions.map((option) => ({
          value: option.value,
          name: option.name,
        })),
      )}
    />
  </div>
</InboxWorkflowPreconfigurationBox>

<style>
  .preconfiguration-grid {
    padding-top: 1rem;
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(2, minmax(12rem, 1fr));
  }
</style>
